<template>
  <i-modal
    :title="$t(isEdit ? 'editing' : 'add', { value: $tc('fabric_type', 1) })"
    :value="value"
    :load="loading"
    @submit="save"
    @input="$emit('input', $event)"
    width="600"
  >
    <div class="modal-body">
      <v-row class="my-0">
        <!-- Campo Nombre del Tipo de Tela -->
        <v-col cols="12">
          <ValidationProvider
            vid="name"
            :name="$tc('name', 1)"
            rules="required|min:2|max:128"
            v-slot="{ errors }"
          >
            <v-text-field
              autofocus
              name="name"
              :error-messages="errors[0]"
              v-model="form.name"
              outlined
              color="secondary"
              :label="$tc('name', 1)"
              :loading="loading"
              @keyup.enter="save"
            />
          </ValidationProvider>
        </v-col>
      </v-row>
    </div>
  </i-modal>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'FabricTypeModal',
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false
    },
    toEdit: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      form: {
        name: ''
      },
      loading: false,
      isEdit: false
    }
  },
  computed: {
    ...mapGetters({
      company: 'company/getCompanyData'
    }),
    companyPk() {
      return this.company ? this.company.pk || this.company.id : null
    }
  },
  watch: {
    toEdit: {
      handler(val) {
        if (val) {
          this.isEdit = true
          this.form.name = val.name || ''
        } else {
          this.isEdit = false
          this.form.name = ''
        }
      },
      immediate: true
    },
    value(val) {
      if (!val) {
        this.form.name = ''
        this.isEdit = false
      }
    }
  },
  methods: {
    async save() {
      if (this.loading) return

      if (!this.form.name || this.form.name.trim() === '') {
        this.$toast.error(this.$t('this_field_is_required'))
        return
      }

      if (this.form.name.length < 2) {
        this.$toast.error(this.$t('min_length', { count: 2 }))
        return
      }

      if (this.form.name.length > 128) {
        this.$toast.error(this.$t('max_length', { count: 128 }))
        return
      }

      this.loading = true
      try {
        const payload = {
          name: this.form.name.trim()
        }
        if (!this.isEdit && this.companyPk) {
          payload.company_id = this.companyPk
        }

        let response
        if (this.isEdit) {
          response = await this.$api.product.fabricType.edit({
            pk: this.toEdit.id || this.toEdit.pk,
            form: payload
          })
          this.$toast.success(this.$t('updated_successfully'))
        } else {
          response = await this.$api.product.fabricType.create({
            form: payload
          })
          this.$toast.success(this.$t('created_successfully'))
        }

        this.$emit('done', response.data)
        this.$emit('input', false)
      } catch (error) {
        this.handleError(error)
      } finally {
        this.loading = false
      }
    },

    handleError(error) {
      if (error.response?.status === 409) {
        this.$toast.error(this.$t('fabric_name_already_exists'))
        return
      }

      if (error.response?.status === 400) {
        const message = error.response.data?.message || ''
        if (message.includes('integrit') || message.includes('foreign key')) {
          this.$toast.error(this.$t('cannot_delete_fabric_in_use'))
          return
        }
      }

      if (error.response?.data?.errors) {
        const backendErrors = error.response.data.errors
        if (backendErrors.name) {
          this.$toast.error(backendErrors.name[0])
          return
        }
        if (backendErrors.company) {
          this.$toast.error(backendErrors.company[0])
          return
        }
      }

      if (error.message?.includes('Network Error')) {
        this.$toast.error(this.$t('network_error'))
      } else {
        this.$toast.error(this.$t('error_saving_fabric'))
      }

      console.error('Error saving fabric type:', error)
    }
  }
}
</script>

<style scoped>
/* Estilos limpios requeridos para el modal */
</style>
